var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"no-close-on-backdrop":"","hide-header-close":"","id":"modal-center","centered":"","title":"Reiniciar Nivel"}},[_c('p',{staticClass:"my-4"},[_vm._v("¿Estas seguro de reiniciar el nivel?")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }